import Link from 'next/link';
import Head from 'next/head';
import SiteSettings from '~/siteSettings';

/**
 * In Page Error
 * @category Functional Component
 * @extends Component
 * @summary Renders an in page error for times you want to display a visual 404 but the page itself did not fail.
 * @return {Node} React node containing rendered component.
 */

const InPageError = () => {
  return (
    <>
      <Head>
        <title>{ `Page Not Found | ${ SiteSettings.siteName }` }</title>
        <meta name='keywords' content='Page not found.' />
      </Head>
      <div className='page-error'>
        <div className='page-error-content'>
          <div>
            <h2>Page Not Found</h2>
            <h1>404</h1>
            <div className='spacer spacer--2'></div>
            <Link href='/'>
              <a className='btn btn--brand'>
                Go To Homepage
              </a>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default InPageError;
